import { useState } from "react";
import { ZyppLiteApi } from "../../../../API/Zypp-Lite-Api/LiteApi";

interface VehicleNumberEditState {
  vehicleId: number;
  currentVehicleNo: string;
  newVehicleNo: string;
}

export const useVehicleNumberEdit = (
  onSuccess: () => void,
  onError: (message: string) => void
) => {
  const [editingVehicle, setEditingVehicle] = useState<VehicleNumberEditState | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const startEdit = (vehicleId: number, currentVehicleNo: string) => {
    setEditingVehicle({
      vehicleId,
      currentVehicleNo,
      newVehicleNo: "",
    });
  };

  const cancelEdit = () => {
    setEditingVehicle(null);
  };

  const updateVehicleNumber = async () => {
    if (!editingVehicle || !editingVehicle.newVehicleNo.trim()) {
      onError("Vehicle number cannot be empty");
      return;
    }

    if (editingVehicle.newVehicleNo === editingVehicle.currentVehicleNo) {
      onError("Please enter a different vehicle number");
      return;
    }

    setIsUpdating(true);

    try {
      const response = await ZyppLiteApi.api?.updateVehicleNumber({
        vehicleId: editingVehicle.vehicleId,
        vehicleNumber: editingVehicle.newVehicleNo,
      });

      if (response?.code === 2000 || response?.status === "success") {
        onSuccess();
        setEditingVehicle(null);
      } else {
        onError(response?.message || "Failed to update vehicle number");
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while updating vehicle number";
      onError(errorMessage);
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    editingVehicle,
    isUpdating,
    startEdit,
    cancelEdit,
    updateVehicleNumber,
    setNewVehicleNo: (value: string) => {
      if (editingVehicle) {
        setEditingVehicle({ ...editingVehicle, newVehicleNo: value });
      }
    },
  };
};
